<section class="admin-page">
  <header class="admin-page__header">
    <div class="admin-page__heading">
      <h1 class="admin-page__title">{{ titleKey() | translate }}</h1>
      @if (subtitleKey()) {
        <p class="admin-page__subtitle">{{ subtitleKey()! | translate }}</p>
      }
    </div>
    <div class="admin-page__actions">
      <ng-content select="[adminPageActions]" />
    </div>
  </header>

  <div class="admin-page__body" [class.admin-page__body--panel]="panelled()">
    <ng-content />
  </div>
</section>
